export default __webpack_public_path__ + "static/media/chrome-tab.c035db51.webp";